import { useEffect } from 'react';
import { useLazyGetGeocodeQuery } from '@/entities';
import { ClientLocationDto } from '@/app/store/api/restApi';
import { setCountryCode, useAppDispatch, useAppSelector } from '@/app/store';

export const useActualisePhoneCountryCode = ({
  locations,
  locationsLoading,
}: {
  locationsLoading: boolean;
  locations: ClientLocationDto[];
}) => {
  const dispatch = useAppDispatch();
  const [triggerGeocode] = useLazyGetGeocodeQuery();
  const { phone } = useAppSelector((state) => state.order);

  useEffect(() => {
    if (phone === '' && !locationsLoading && locations.length > 0) {
      const setPhoneCountryCode = async () => {
        try {
          const firstCreatedLocationCoords = locations[locations.length - 1].coordinates;
          const geocodeData = await triggerGeocode({
            geocode: `${firstCreatedLocationCoords.lng},${firstCreatedLocationCoords.lat}`,
          }).unwrap();
          if (geocodeData.response && geocodeData.response.GeoObjectCollection) {
            const countryCode =
              geocodeData.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData
                .Address.country_code;
            if (countryCode && typeof countryCode === 'string') dispatch(setCountryCode(countryCode.toLowerCase()));
          }
        } catch {
          console.log('Ошибка определения кода страны');
        }
      };

      setPhoneCountryCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, locations, locationsLoading, triggerGeocode]);
};
